/**
 * Angular imports.
 */
import { Component, Input, Output, OnChanges, EventEmitter } from '@angular/core';

/**
 * Service imports.
 */
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { PostingService } from '../posting.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME } from 'src/app/constants/app.constants';

/**
 * Post Processing Component
 */
@Component({
  selector: 'app-post-processing',
  templateUrl: './post-processing.component.html',
  styleUrls: ['./post-processing.component.scss']
})
export class PostProcessingComponent implements OnChanges {
  @Input() feed_post_in_process;
  @Input() userctivity;
  @Output() resetUploadComplete = new EventEmitter();
  public is_failed = false;
  public timer = 0;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    public masterService: MasterserviceService,
    public dss: DataStorageService,
    public multilang: MultiLangService,
    public mls: NewLanguageService,
    public fcs: FunCollectionService,
    private analyticSdk: Analytics,
    private postingService: PostingService) {
  }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    if (this.feed_post_in_process.status == 'completed') {
      setTimeout(() => {
        this.resetData();
      }, 2000);

    }
  }

  /**
   * resetData
   */
  resetData(): void {
    this.feed_post_in_process.is_show = false;
    this.resetUploadComplete.emit(false);
  }

  /**
   * retryFeedPost
   */
  retryFeedPost(): boolean {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.POST_TRYAGAIN, null);
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    this.dss.posting_data.screen1.media = [];
    this.uploadFile();
  }

  /**
   * cancel Post
   */
  cancelPost(): void {
    this.dss.resetPostData();
    this.dss.temp_post_media = [];
    this.resetData();
  }

  /**
   * upload File
   */
  uploadFile(): void {
    if (this.dss.posting_data.feed_edit_mode.is_edit == 1) {
      this.uploadFileForEditFeedPost(); return;
    }
    this.postingService.uploadFile();
  }

  /**
   * feed Post
   */
  feedPost(): void {
    this.postingService.feedPost();
  }

  /**
   * upload File For Edit Feed Post
   */
  uploadFileForEditFeedPost(): void {
    this.postingService.uploadFileForEditFeedPost();
  }

  /**
   * feed Edit Post
   */
  feedEditPost(): void {
    this.postingService.feedEditPost();
  }
}
